<template>

  <div class="main" v-loading="loading" element-loading-text="加载中" element-loading-spinner="el-icon-loading">
    <div class="main-container" v-if="list && list.length > 0">
      <el-row :gutter="20">
        <el-col :span="6" v-for="(item,index) in list" :key="index">
          <grid-box :item="item" @pages="clickRouter"></grid-box>
        </el-col>
      </el-row>

      <div class="flex flex_align-items flex_justify-center">
        <el-pagination
            :current-page.sync="current_page"
            @current-change="handleCurrentChange"
            background
            :page-size="12"
            layout="prev, pager, next"
            :total="page.count">
        </el-pagination>
      </div>

    </div>
    <EmptyView v-else></EmptyView>
  </div>

</template>

<script>
import gridBox from '../compoents/grid-box'

export default {
  components: {
    gridBox
  },
  data() {
    return {
      list: [],
      userInfo: {},
      page: {},
      loading: true,
      current_page: 1
    }
  },
  methods: {
    async handleCurrentChange(e) {
      this.current_page = e
      this.loading = true
      this.list = []
      let coursePcList = await this.getCoursePcList(e)
      this.page = coursePcList.data
      this.list = coursePcList.data && coursePcList.data.list || []
    },
    clickRouter(e) {
      if (!this.userInfo.idCard) {
        this.$alert('系统检测到您还未绑定身份证信息，不能观看视频，请前去绑定身份证信息?', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
        }).then(() => {
          setTimeout(() => {
            this.$router.push('/homeUser/userInfo')
          }, 1000)
        })
      } else {
        this.$router.push({
          path: '/homeCourse',
          query: {
            courseId: e.studyCourse.id,
          }
        })
      }
    },
    getCoursePcList(pageNo) {
      return new Promise(resolve => {
        this.$get(this.$API.MY_COURSE_PC_LIST, {
          pageNo,
          pageSize: 12
        }).then(res => {
          setTimeout(() => {
            this.loading = false
          }, 500)
          resolve(res)
        })
      })
    }
  },
  async created() {

    this.$get(this.$API.MEMBER_INFO, {}).then(res => {
      if (res.code === 200) {
        this.userInfo = res.data
        this.$emit('user', this.userInfo)
      }
    })

    let coursePcList = await this.getCoursePcList(1)
    this.page = coursePcList.data
    this.list = coursePcList.data && coursePcList.data.list || []
  },
}

</script>

<style scoped lang="scss">
.main-container {
  width: 100%;
  margin-top: 30px;
}
</style>
